import React from "react";

/**
 * The rounded gradient tile the Widgets Studio uses for every widget icon.
 * The others are PNGs; this one is drawn, so the Dashboard widget can sit
 * beside them without shipping another asset.
 */
const DashboardTile = ({ size = 48, radius = 16 }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: size,
      height: size,
      borderRadius: radius,
      background: "linear-gradient(135deg, #E935C1 0%, #B429C4 100%)",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.12)",
      flex: "none",
    }}
  >
    <svg
      width={Math.round(size * 0.5)}
      height={Math.round(size * 0.5)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3" y="3" width="7" height="9" rx="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1.5" />
    </svg>
  </span>
);

export default DashboardTile;
